var updateStoreAvailabilityDeliver = function() {
  // Order Timer
  if(jQuery('.timer').length) {
    if(jQuery('#addToCart').is(':disabled')) {
      jQuery('.no-timer-no-stock').show();
    } else {
      var hourLimit = 14;
      var countdown = new Date();
      var currentDay = countdown.getDay();
  
      if (jQuery('.timer-container').next().find('.testament--apollo-close').length) {
        jQuery('.timer-container').hide();
      } else {
        jQuery('.timer-container').show();
      }
      // Remove timer if it's after 14:00 on a weekday or a weekend day, otherwise show it
      //if (currentDay == 0 || currentDay == 6 || (countdown.getHours() >= hourLimit)) {
      if (currentDay == 0 || currentDay == 6 || (currentDay == 5 && countdown.getHours() >= hourLimit)) {
        jQuery('.no-timer').show();
      } else {
        jQuery('.timer').show();
        // This is only used for testing, keep
        if (countdown.getHours() >= hourLimit) {
          countdown.setDate(countdown.getDate() + 1)
        }
        countdown = countdown.setHours(hourLimit, 0, 0);
        var second = 1000;
        var minute = second * 60;
        var hour = minute * 60;
        var day = hour * 24;
        var x = setInterval(function() {
          let timeNow = new Date().getTime();
          let timeDifference = countdown - timeNow;
          let hoursRemaining = 0;
          let minutesRemaining = 0;
          let secondsRemaining = 0;
          let dayText = 'today';
          if (timeDifference > 0) {
            hoursRemaining = Math.floor((timeDifference % day) / hour); 
            minutesRemaining = Math.floor((timeDifference % hour) / minute);
            secondsRemaining = Math.floor((timeDifference % minute) / second);
          }
          jQuery('.js-timer-hours').text(addLeadingZero(hoursRemaining));
          jQuery('.js-timer-minutes').text(addLeadingZero(minutesRemaining));
          jQuery('.js-timer-seconds').text(addLeadingZero(secondsRemaining));
  
          if (hoursRemaining >= 12) {
            dayText = 'tomorrow';
          }
          jQuery('.js-timer-day').text(dayText);
        }, second);
      }
    }
  }
};

var addLeadingZero = function(value) {
  if (value < 10) {
    return '0' + value;
  }
  
  return value;
};